import * as d3 from 'd3'
export default {

  methods: {

    set_LocalValues(){

      this.dataSource = JSON.parse(JSON.stringify(this.DataItems[0]))

      this.sumData = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))
      this.rawData = this.Queries.SQL2 ? JSON.parse(JSON.stringify(this.Queries.SQL2)) : []
      this.dataSet = this.rawData

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.scroll   = json.scroll
      this.summary  = json.summary
      this.header   = json.header
      this.columns  = json.columns

      this.sundries = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters

      // Scroll
      this.scroll.bar = {...json.scroll.bar,
        y: 0,
        size: null,
        ratio: null,
        space: null,
      }
      this.scroll.content = {y: 0, height: null, },
      this.scroll.wheel = {count: 0, step: null, ratio: null, }

      // Summary
      this.gmx_tableCoordinates('x', this.summary.cols, 0)
      this.summary.width = this.summary.cols[this.summary.cols.length-1].ex
      this.summary.y = this.summary.y=='auto' ? this.scroll.viewbox.y - this.header.height - 13: this.summary.y

      // Column
      this.gmx_tableCoordinates('x', this.columns, 5)
      if(this.scroll.viewbox.width != 785) this.scroll.viewbox.width = this.columns[this.columns.length-1].ex + 10

      this.header.width = this.scroll.viewbox.width
    },

    set_Filtering(status) {
      console.log(status)

      if(status == 'ALL') this.dataSet = this.rawData
      else this.dataSet = this.rawData.filter(f=> f.STATUS == status)

      this.canvasContents.remove()
      this.draw_ViewBox()
    },

    set_ScrollValues() {

      // Scroll Pre-Proceassing
      this.scroll.bar.size = this.scroll.viewbox.height / this.scroll.content.height * this.scroll.viewbox.height

      this.scroll.viewbox.space = this.scroll.content.height - this.scroll.viewbox.height
      this.scroll.wheel.step = parseInt(this.scroll.viewbox.space/30)
      this.scroll.wheel.ratio = 1 / this.scroll.wheel.step
      
      this.scroll.bar.space = this.scroll.viewbox.height - this.scroll.bar.size
      this.scroll.bar.ratio = this.scroll.bar.space / this.scroll.wheel.step
      
      if((this.scroll.content.height > this.scroll.viewbox.height)) this.draw_Scrollbar()
      
    },

  }
}